// Runtime backend URL resolver
// On preview environments, uses the build-time env var
// On production custom domains, uses same-origin (since backend is co-hosted)
const BACKEND_URL = (typeof window !== 'undefined' &&
  !window.location.hostname.includes('preview.emergentagent.com') &&
  !window.location.hostname.includes('localhost'))
  ? window.location.origin
  : (process.env.REACT_APP_BACKEND_URL || '');

export default BACKEND_URL;
